import { render, staticRenderFns } from "./StudentsEdit.vue?vue&type=template&id=38a26f36&scoped=true&"
import script from "./StudentsEdit.vue?vue&type=script&lang=js&"
export * from "./StudentsEdit.vue?vue&type=script&lang=js&"
import style0 from "./StudentsEdit.vue?vue&type=style&index=0&id=38a26f36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a26f36",
  null
  
)

export default component.exports